import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export type TypeCouverture = 'BASSIN' | 'TROUPEAU' | 'ANIMAL' | 'LOT_VOLAILLE' | 'PISCICULTURE' | 'CULTURE'
  | 'ARTICLE_STOCK' | 'EQUIPEMENT';

/** Photos d'un élément pour sa carte : identifiants (plus récentes d'abord) et nombre total */
export interface Couverture { lienId: number; photos: number[]; nombre: number; }

/**
 * Couvertures des cartes : une seule requête par liste (pas une par carte) ; vignettes immuables
 * gardées en mémoire pour la session (une image n'est téléchargée qu'une fois).
 */
@Injectable({ providedIn: 'root' })
export class CouverturesService {

  private readonly docs = `${environment.BASE_URL}/api/documents`;
  private readonly vignettes = new Map<number, Observable<string | null>>();

  constructor(private http: HttpClient) {}

  /** lienId → couverture ; vide si l'API ne répond pas (les cartes gardent leur visuel par type) */
  pour(fermeId: number | null | undefined, lienType: TypeCouverture, max = 3): Observable<Map<number, Couverture>> {
    const params: any = { lienType, max };
    if (fermeId) { params.fermeId = fermeId; }
    return this.http.get<Couverture[]>(`${this.docs}/couvertures`, { params }).pipe(
      map(l => new Map((l || []).map(c => [Number(c.lienId), c] as [number, Couverture]))),
      catchError(() => of(new Map<number, Couverture>()))
    );
  }

  /** Adresse locale (blob:) de la vignette, partagée entre les cartes */
  vignette(id: number): Observable<string | null> {
    let v = this.vignettes.get(id);
    if (!v) {
      v = this.http.get(`${this.docs}/${id}/miniature`, { responseType: 'blob' }).pipe(
        map(b => URL.createObjectURL(b)),
        catchError(() => of(null)),
        shareReplay(1)
      );
      this.vignettes.set(id, v);
    }
    return v;
  }
}
